import { Trans, useTranslation } from 'react-i18next';
import { BsTable } from 'react-icons/bs';
import { Link } from 'react-router-dom';

type ReportDetailsButtonProps = {
    id: number;
};

export default function ReportDetailsButton({ id }: ReportDetailsButtonProps) {
    useTranslation();
    return (
        <Link
            className="workplace-action-btn cursor--pointer link-dark text-decoration-none"
            to={'/reportdetails/' + id}
            target="_blank"
        >
            <BsTable className="workplace-action-btn__icon" />
            <span>
                <Trans i18nKey="BackOfficeOnScreen" />
            </span>
        </Link>
    );
}
